import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  resources: [],
  loading: false,
  resourcesPagination: {},
});

export default function allocatedResourcesReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS.RESOURCES.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.RESOURCES.SUCCESS: {
      return state
        .set("error", "")
        .set("resources", action.data.data)
        .set("resourcesPagination", action.data.pagination)
        .set("loading", false);
    }
    case ACTIONS.RESOURCES.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    case ACTIONS.SORT_RESOURCES.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.SORT_RESOURCES.SUCCESS: {
      return state
        .set("error", "")
        .set("resources", action.data.data)
        .set("resourcesPagination", action.data.pagination)
        .set("loading", false);
    }
    case ACTIONS.SORT_RESOURCES.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    default: {
      return state;
    }
  }
}
